import { Disc3, Image as ImageIcon, Info, Settings } from 'lucide-react';
import type { MenuMode } from '@/hooks/usePlayer';
import { paths } from '@/lib/routes';

const TABS: {
  key: MenuMode;
  label: string;
  to: string;
  Icon: typeof Disc3;
}[] = [
  { key: 'music', label: 'Music', to: paths.music(), Icon: Disc3 },
  { key: 'photo', label: 'Photo', to: paths.photo(), Icon: ImageIcon },
  { key: 'info', label: 'Info', to: paths.info(), Icon: Info },
  { key: 'settings', label: 'Settings', to: paths.settings(), Icon: Settings },
];

type Props = {
  mode: MenuMode;
  onSwitch: (mode: MenuMode) => void;
};

export function MobileTabBar({ mode, onSwitch }: Props) {
  return (
    <nav className="mobile-tab-bar" aria-label="Primary">
      {TABS.map(({ key, label, Icon }) => {
        const active = mode === key;
        return (
          <button
            key={key}
            type="button"
            className={`mobile-tab-item${active ? ' is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
            onClick={() => onSwitch(key)}
          >
            <Icon
              size={22}
              strokeWidth={active ? 2.25 : 1.75}
              aria-hidden
            />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
